import(/* webpackMode: "eager" */ "/opt/gdocnext_dev/app/loading.tsx");
